import axios from "axios";
import {getToken} from "../service/auth.service";

export function getFeeds({ search, limit, offset, params }: any)  {
    // const [_key, { search, limit, offset }] = queryKey;
    return axios
        .get<any>(`${window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL}/api/v1/feeds/`, {headers: { Authorization: `Bearer ${getToken()}` }, params: {search, limit, offset, ...params}})
        .then(res => res.data);
}

export function deleteFeed(id: string) {
    return axios
        .delete<any>(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/feeds/delete/${id}`, {headers: { Authorization: `Bearer ${getToken()}` }})
        .then(res => res.data)
}